
















import Vue, { PropType } from 'vue';
import _ from '../../utils';

export default Vue.extend({
  props: {
    value: { default: undefined, type: [Object, String, Boolean, Array, Error] as PropType<any> },
    dismissable: { default: true, type: Boolean },
    showFieldNames: { default: true, type: Boolean },
  },
  computed: {
    computedType(): string {
      if (this.value && this.value.status === 400) {
        return 'warning';
      }
      return 'error';
    },
    parsedTitle(): string | undefined {
      if (typeof this.value === 'string') {
        return this.value;
      }
      if (!_.isObject(this.value)) {
        return undefined;
      }
      const title = this.value.data?.info?.errorInfo?.title;
      if (title !== undefined) {
        return title;
      }
      const message = this.value.message ?? this.value.data?.info?.message;
      return message;
    },
    parsedMessages(): string[] {
      if (!_.isObject(this.value)) {
        return [];
      }
      const details = this.value.data?.info?.errorInfo?.details;
      if (typeof (details) === 'string' && details !== '') {
        return [details];
      }
      if (_.isObject(details)) {
        return Object.keys(details).map((key) => (this.showFieldNames ? `${key}: ${details[key]}` : `${details[key]}`));
      }
      if (typeof this.value.detailMessage === 'string') {
        return [this.value.detailMessage];
      }
      return [];
    },
  },
});
